export const centsToPrice = (cents: number) => {
    return cents / 100;
};
